import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserNotificationService } from 'app/services/models/user-notification.service';

@Component({
  selector: 'app-has-reader-notification-dialog',
  templateUrl: './has-reader-notification-dialog.component.html',
  styleUrls: ['./has-reader-notification-dialog.component.scss']
})
export class HasReaderNotificationDialogComponent implements OnInit {
  @Input() id;

  hasReaderUsersData:any[] = [];

  constructor(public activeModal: NgbActiveModal, private userNotificationService: UserNotificationService) { }

  async ngOnInit() {
    if (this.id) {
      await this.hasReaderUsers(this.id)
    }
  }

  closeModal(){
    this.activeModal.close();
  }

  async hasReaderUsers(id) {
    const data = await this.userNotificationService.hasReaderNotification(id);
    console.log(data);
    this.hasReaderUsersData = data;
  }
}
